export default __webpack_public_path__ + "static/SourceCodePro.bold-00287aec409ee9fcf654f0c4cede9549.woff";